export const Constants = {
    global: {
        A: 22
    },
    math: {
        PI: 3.141592,
        E: 2.7172
    }
}